import { createAction } from '@ngrx/store';

export const googleMapsReady = createAction('[Google maps] Ready');
